<!--MRCP（可选）-->
<script setup>
import {ref, computed, reactive } from "vue";
import upload from "@/components/upload1.vue"
import check from "./check.vue";
import uploadzip from "@/components/upload.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;align-items: center;">
      <h2>MRCP（可选）</h2>
      <upload v-if="crfFields['患者是否进行MRCP检查？'] == '是' && crfFields['MRCP检查是否适用肝筛选期数据'] == '否'" :type="props.type" :data="model" name="mrcpkx"></upload>
      <check :period="props.type" text="MRCP（可选）" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="MRCP检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['MRCP检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['MRCP检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'患者是否新增MRCP检查？':'患者是否进行MRCP检查？'" class="not_redStar">
          <el-radio-group v-model="crfFields['患者是否进行MRCP检查？']">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="crfFields['患者是否进行MRCP检查？'] == '是'">
            <uploadzip :type="props.type" :data="model" name="mrcpzip"></uploadzip>
            
        </template>
      </template>
  </template>

</template>

<style scoped>

</style>